import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import Checklist from 'components/lib/checklist';
import { Channel } from 'models/search/search_filter';

const channelOptions = [
  {
    id: Channel.CHAT_MESSAGE,
    label: 'Chat',
  },
  {
    id: Channel.EMAIL,
    label: 'Email',
  },
  {
    id: Channel.FB_MESSAGE,
    label: 'Facebook',
  },
  {
    id: Channel.INSTAGRAM_DIRECT,
    label: 'Instagram Direct',
  },
  {
    id: Channel.PHONE_CALL,
    label: 'Phone',
  },
  {
    id: Channel.SMS,
    label: 'SMS',
  },
  {
    id: Channel.TWITTER,
    label: 'Twitter',
  },
  {
    id: Channel.VOICEMAIL,
    label: 'Voicemail',
  },
  {
    id: Channel.WHATSAPP,
    label: 'WhatsApp',
  },
];

const ChannelFilter = function({
  fbMessengerEnabled,
  isChatEnabled,
  isInstagramDirectEnabled,
  isWhatsAppEnabled,
  isTwitterEnabled,
  onChange,
  selectedChannels,
}) {
  let options = channelOptions
    .filter(channel => fbMessengerEnabled || channel.id !== Channel.FB_MESSAGE)
    .filter(channel => isChatEnabled || channel.id !== Channel.CHAT_MESSAGE)
    .filter(channel => isInstagramDirectEnabled || channel.id !== Channel.INSTAGRAM_DIRECT)
    .filter(channel => isWhatsAppEnabled || channel.id !== Channel.WHATSAPP)
    .filter(channel => isTwitterEnabled || channel.id !== Channel.TWITTER)
    .map(channel => {
      return { value: channel.id, label: channel.label, isSelected: selectedChannels.indexOf(channel.id) > -1 };
    });

  return <Checklist options={options} onChange={onChannelChange} />;

  function onChannelChange(channel, isSelected) {
    let channels = isSelected ? _.union(selectedChannels, [channel]) : _.difference(selectedChannels, [channel]);
    onChange({ channels });
  }
};

ChannelFilter.propTypes = {
  isChatEnabled: PropTypes.bool,
  fbMessengerEnabled: PropTypes.bool,
  isInstagramDirectEnabled: PropTypes.bool,
  isWhatsAppEnabled: PropTypes.bool,
  isTwitterEnabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  selectedChannels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ChannelFilter;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/search/filters/channel_filter.jsx